import SuperRepository from '../superRepository'

export default new (class PartnerSpendLogRepository extends SuperRepository {
  baseUri() {
    return 'partner_spend_log'
  }
  exportPartnerSpendLogToken = (data, params) =>
    this.reportHttpClient().postQuery('export/partner_spend_log/token', data, params)
})()
